import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'
import { QntmDto } from '../dto/qntm.dto'
import { QntmModel } from '../models'
import fromDtoToQntmModelTransformer from '../transformers/from-dto-to-qntm-model.transformer'

/**
 * Fetches all Qntm sub-devices for a given installation and device link.
 *
 * @param installationId - The installation ID (iid)
 * @param deviceId - The device link ID (did)
 * @param authFetch
 */
export const fetchQntmByInstallation = async (
  installationId: string | number,
  deviceId: string | number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<QntmModel[]>> => {
  try {
    const response = await authFetch<QntmDto>({
      path: `installations/${installationId}/device-links/${deviceId}/sub/qntm-storage`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const data = fromDtoToQntmModelTransformer(response.data)
      return new ApiResult<QntmModel[]>(data)
    }

    return new ApiResult<QntmModel[]>(null, true)
  } catch (error) {
    return handleFetchError<QntmModel[]>(error)
  }
}
